import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/ev_charging_station_settlements',
  component: Management,
  redirect: '/ev_charging_station_settlements/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/ev_charging_station_settlements/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listEvChargingStationSettlements
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/ev_charging_station_settlements/ListTable'),
          meta: {
            auth: Auth.listEvChargingStationSettlements,
            tabName: 'all'
          }
        },
        {
          path: 'ecmp_charging_settlements',
          component: () => import('@/views/ev_charging_station_settlements/ListTable'),
          meta: {
            auth: Auth.listEvChargingStationSettlements,
            tabName: 'ecmp_charging_settlements'
          }
        },
        {
          path: 'evcs_charging_settlements',
          component: () => import('@/views/ev_charging_station_settlements/ListTable'),
          meta: {
            auth: Auth.listEvChargingStationSettlements,
            tabName: 'evcs_charging_settlements'
          }
        },
        {
          path: 'idle_fee_settlements',
          component: () => import('@/views/ev_charging_station_settlements/ListTable'),
          meta: {
            auth: Auth.listEvChargingStationSettlements,
            tabName: 'idle_fee_settlements'
          }
        },
        {
          path: 'fail_settlements',
          component: () => import('@/views/ev_charging_station_settlements/ListTable'),
          meta: {
            auth: Auth.listEvChargingStationSettlements,
            tabName: 'fail_settlements'
          }
        },
        {
          path: 'station_daily_settlements',
          component: () => import('@/views/station_daily_settlements/ListTable'),
          meta: {
            auth: Auth.listEvChargingStationSettlements,
            tabName: 'station_daily_settlements'
          }
        },
        {
          path: 'service_provider_daily_settlements',
          component: () => import('@/views/service_provider_daily_settlements/ListTable'),
          meta: {
            auth: Auth.listEvChargingStationSettlements,
            tabName: 'service_provider_daily_settlements'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/ev_charging_station_settlements/New'),
      meta: {
        auth: Auth.createEvChargingStationSettlement
      }
    },
    // 预览
    {
      path: 'preSettlement',
      component: () => import('@/views/ev_charging_station_settlements/PreSettlement'),
      meta: {
        auth: Auth.createOrderPreSettlement
      }
    },
    // 充电站日结算详情
    {
      path: 'station_daily_settlement_detail',
      component: () => import('@/views/station_daily_settlements/DetailLayout'),
      meta: {
        auth: Auth.showEvChargingStationSettlement
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/station_daily_settlements/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvChargingStationSettlement
          }
        },
        // 结算明细
        {
          path: 'settlements',
          component: () => import('@/views/station_daily_settlements/details/Settlements'),
          meta: {
            tabName: 'settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvChargingStationSettlement
          }
        }
      ]
    },
    // 运营商日结算详情
    {
      path: 'service_provider_daily_settlement_detail',
      component: () => import('@/views/service_provider_daily_settlements/DetailLayout'),
      meta: {
        auth: Auth.showEvChargingStationSettlement
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/service_provider_daily_settlements/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvChargingStationSettlement
          }
        },
        // 充电站日结算
        {
          path: 'station_daily_settlements',
          component: () => import('@/views/service_provider_daily_settlements/details/StationDailySettlements'),
          meta: {
            tabName: 'station_daily_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvChargingStationSettlement
          }
        },
        // 结算明细
        {
          path: 'settlements',
          component: () => import('@/views/service_provider_daily_settlements/details/Settlements'),
          meta: {
            tabName: 'settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvChargingStationSettlement
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/ev_charging_station_settlements/DetailLayout'),
      meta: {
        auth: Auth.showEvChargingStationSettlement
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/ev_charging_station_settlements/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvChargingStationSettlement
          }
        },
        // 基本信息（优惠结算）
        {
          path: 'discount_settlement_detail',
          component: () => import('@/views/ev_charging_station_settlements/details/DiscountSettlementDetail'),
          meta: {
            tabName: 'discount_settlement_detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvChargingStationSettlement
          }
        },
        // 基本信息（充电包结算）
        {
          path: 'charging_package_settlement_detail',
          component: () => import('@/views/ev_charging_station_settlements/details/ChargingPackageSettlementDetail'),
          meta: {
            tabName: 'charging_package_settlement_detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEvChargingStationSettlement
          }
        },
        // 订单结算
        {
          path: 'order_settlements',
          component: () => import('@/views/ev_charging_station_settlements/details/OrderSettlements'),
          meta: {
            tabName: 'order_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listOrderSettlements
          }
        },
        // 占位费结算
        {
          path: 'idle_fee_bill_settlements',
          component: () => import('@/views/ev_charging_station_settlements/details/IdleFeeBillSettlements'),
          meta: {
            tabName: 'idle_fee_bill_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listIdleFeeBillSettlements
          }
        },
        // 优惠结算
        {
          path: 'discount_settlements',
          component: () => import('@/views/ev_charging_station_settlements/details/DiscountSettlements'),
          meta: {
            tabName: 'discount_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listOrderDiscountSettlements
          }
        },
        // 充电包结算
        {
          path: 'charging_package_settlements',
          component: () => import('@/views/ev_charging_station_settlements/details/ChargingPackageSettlements'),
          meta: {
            tabName: 'charging_package_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listChargingPackageSettlements
          }
        }
      ]
    }
  ]
}
